import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ShoppingService } from '../core/services/shopping.service';
import { appVariables, appApiResources } from '../core/constants/Common.constant';
import { HelperService } from '../core/services/helper.service';


@Component({
  selector: 'app-shoppingcart',
  templateUrl: './shoppingcart.component.html',
  styleUrls: ['./shoppingcart.component.css']
})
export class ShoppingcartComponent implements OnInit, AfterViewInit {
  public loading = false;

  constructor(private activatedRoute: ActivatedRoute, private router: Router, private shoppingService: ShoppingService
    , private helperService: HelperService) { }

  ngAfterViewInit() {
    setTimeout(() => {
      this.helperService.observeLoading.subscribe(loadingobj => {
        this.loading = loadingobj;
      });
    });
  }
  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/shoppingcart/shoppingcart.component.ts